/*
 * @Description: 文件选择上传（支持多文件）
 * @Author: linchen
 * @Date: 2020-06-15
 */
import React, { Component } from 'react';
import { Flex, ImagePicker, Toast } from 'antd-mobile';
import Upload from 'utils/upload';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class FilePickerView extends Component {
  // 属性声名
  static propTypes = {
    bigSize: PropTypes.bool // 要通过500M限制的文件 上传要加这个参数
  };

  static defaultProps = {
    bigSize: false
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.inputRef = null;
  }

  upload = (file) => {
    const { onChange, bigSize } = this.props;
    if (file && file.length == 0) return;
    Toast.loading('上传中,请稍后', 100);

    Upload.uploadAnnex2OSS({ file: file[0], scene: this.props.scene || '' })
      .then((res) => {
        Toast.hide();
        onChange && onChange(res, file[0].name);
      })
      .catch((err) => {
        Toast.info(err.message || '上传失败，请重新上传');
      });
  };

  render() {
    const { children, editabled = true, style, className, accept, type } = this.props;
    return (
      <div style={style}>
        {editabled && (
          <input
            type="file"
            onChange={(e) => this.upload(e.currentTarget.files, type)}
            ref={(ref) => {
              this.inputRef = ref;
            }}
            style={{ display: 'none' }}
            className={className || ''}
            accept={accept || ''}
          />
        )}
        <div className="file-upload-wrap" onClick={(e) => this.inputRef.click()}>
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/FilePicker/index.js